module.exports = __webpack_public_path__ + "media/invest/historical-performance-34546c7d.png";